export function deviceOption(dev) {
  return { id: dev.deviceId, text: dev.label, isDefault: dev.deviceId == 'default' }
}
